// ViewerAdapter — abstraktní integrační rozhraní mezi BCF vrstvou a IFC viewerem
// (§8). BCF logika NESMÍ používat API konkrétního vieweru mimo tento adapter.
// Tím lze později vyměnit IFC engine (Flinker / That Open / xeokit / vlastní) bez
// přepsání BCF modulu. Metody pracují s IFC souřadnicemi a { modelId, globalId }.
export class ViewerAdapter {
  // Kamera v IFC souřadnicích: { type:'perspective'|'orthogonal', position, direction, up, fieldOfView?, viewToWorldScale? }
  getCamera() { throw new Error("ViewerAdapter.getCamera not implemented"); }
  setCamera(_camera) { throw new Error("not implemented"); }

  // Výběr / komponenty — pole { modelId, globalId }.
  getSelectedComponents() { throw new Error("not implemented"); }
  selectComponents(_refs) { throw new Error("not implemented"); }
  clearSelection() { throw new Error("not implemented"); }

  // Viditelnost — { defaultVisibility:boolean, exceptions:ref[] }.
  getVisibility() { throw new Error("not implemented"); }
  applyVisibility(_v) { throw new Error("not implemented"); }
  showAll() { throw new Error("not implemented"); }

  // Řezné roviny v IFC souřadnicích — { location, direction }[].
  getClippingPlanes() { throw new Error("not implemented"); }
  setClippingPlanes(_planes) { throw new Error("not implemented"); }
  clearClippingPlanes() { throw new Error("not implemented"); }

  // Zvýraznění / barvy.
  highlightComponents(_refs) { throw new Error("not implemented"); }
  applyColoring(_coloring) { throw new Error("not implemented"); }
  resetColors() { throw new Error("not implemented"); }

  // Snímek pohledu (PNG).
  captureSnapshot() { throw new Error("not implemented"); }

  // Kontext modelů.
  listModels() { throw new Error("not implemented"); }
  hasComponent(_modelId, _globalId) { throw new Error("not implemented"); }
  primaryModelId() { throw new Error("not implemented"); }

  resetView() { throw new Error("not implemented"); }
}
